export default __webpack_public_path__ + "static/media/status_green.4da64b6a.svg";